var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.94 18.8775C16.2306 20.1805 14.1491 20.9024 12 20.9375C5 20.9375 1 12.9375 1 12.9375C2.24389 10.6194 3.96914 8.59413 6.06 6.99753M9.9 5.17752C10.5883 5.0164 11.2931 4.93586 12 4.93753C19 4.93753 23 12.9375 23 12.9375C22.393 14.0731 21.6691 15.1423 20.84 16.1275M14.12 15.0575C13.8454 15.3523 13.5141 15.5887 13.1462 15.7526C12.7782 15.9166 12.3809 16.0048 11.9781 16.0119C11.5753 16.019 11.1752 15.9449 10.8016 15.794C10.4281 15.6431 10.0887 15.4186 9.80385 15.1337C9.51897 14.8488 9.29439 14.5095 9.14351 14.1359C8.99262 13.7624 8.91853 13.3622 8.92563 12.9594C8.93274 12.5566 9.02091 12.1594 9.18488 11.7914C9.34884 11.4234 9.58525 11.0922 9.88 10.8175",
    stroke: "#1BA0DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.9375L23 23.9375",
    stroke: "#1BA0DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.fa54a86c0bd86c7698672b446ee71390.svg";
export { ForwardRef as ReactComponent };